import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { notification } from "antd";
import moment from "moment";

import { Button, OTPInput } from "components";
import {
  VerifyOTPActionCreators,
  VerifyPhoneNumberActionCreators,
  VoiceCallActionCreators,
} from "redux/rootActions";
import {
  verifyOTPDataResponse,
  selectIsVerifyOTP,
} from "redux/setting/verifyOTP/verifyOTPStates";
import { verifyPhoneNumberDataResponse } from "redux/setting/verifyPhoneNumber/verifyPhoneNumberStates";
import { voiceCallDataResponse } from "redux/setting/voiceCall/voiceCallStates";
import { httpStatus } from "configs/httpStatus";
import { theme } from "theme/theme";

import { Title } from "./NursingHomeRegistration";
import { SendCompleteIcon } from "icons";

const Wrapper = styled.div``;

const Text = styled.div`
  font-family: Noto Sans JP;
  font-weight: 500;
  font-size: 16px;
  line-height: 19.2px;
  letter-spacing: 0px;
  text-align: center;
  color: #3b3b3b;
  margin-bottom: 8px;
  text-align: center;
`;

const SecondText = styled.div`
  font-family: Noto Sans JP;
  font-weight: 400;
  font-size: 14px;
  line-height: 16.8px;
  letter-spacing: 0%;
  color: #1a2f62;
  margin-bottom: 24px;
  text-align: left;

  span {
    font-family: Noto Sans JP;
    font-weight: 700;
    font-size: 14px;
    line-height: 16.8px;
    letter-spacing: 0%;
    color: #2f8cae;
  }
`;

const ThirdText = styled.div`
  font-family: Noto Sans JP;
  font-weight: 400;
  font-size: 12px;
  line-height: 14.4px;
  letter-spacing: 0%;
  color: #666666;
  margin-bottom: 12px;
  cursor: pointer;
`;

const FourText = styled.div`
  font-family: Noto Sans JP;
  font-weight: 400;
  font-size: 12px;
  line-height: 14.4px;
  letter-spacing: 0%;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-offset: Auto;
  text-decoration-thickness: Auto;
  color: #2f8cae;
  margin-bottom: 11px;
  cursor: pointer;
`;

const FiveText = styled(FourText)`
  margin-bottom: 32px;
`;

const WrapperError = styled.div`
  color: ${theme.colors.error};
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 24px;
  text-align: center;
`;

const VerifyOTP: React.FC = () => {
  const dispatch = useDispatch();
  const verifyOTPData = useSelector(verifyOTPDataResponse);
  const verifyPhoneNumberData = useSelector(verifyPhoneNumberDataResponse);
  const voiceCallData = useSelector(voiceCallDataResponse);
  const isLoading = useSelector(selectIsVerifyOTP);

  const { search } = useLocation();
  const phone: any = "+" + new URLSearchParams(search).get("phone")?.slice(1);
  const superCityName: any = new URLSearchParams(search).get("name");
  const superCityCode: any = new URLSearchParams(search).get("super-city-code");

  const [otpCode, setOtpCode] = useState("");
  const [error, setError] = useState("");

  const handleOTPComplete = (otp: any) => {
    setOtpCode(otp);
  };

  const handleVerify = () => {
    if (!otpCode.length) {
      setError("認証コードを入力してください");
      return;
    }

    const params = { mobile_number: phone, otp: otpCode };

    dispatch(VerifyOTPActionCreators.verifyOTPAction(params));
  };

  useEffect(() => {
    if (verifyOTPData) {
      if (verifyOTPData.status === httpStatus.StatusOK) {
        localStorage.setItem("type_form", "full");
        const searchParams = window.location.search;
        window.location.replace(`/account-registration${searchParams}`);
      } else {
        setError("暗証番号(OTP)が間違っています。");
      }
      dispatch(VerifyOTPActionCreators.handleResetAction());
    }
  }, [verifyOTPData]);

  useEffect(() => {
    if (
      verifyPhoneNumberData &&
      verifyPhoneNumberData.status === httpStatus.StatusOK
    ) {
      notification.open({
        message: moment(new Date()).format("YYYY/MM/DD HH:mm"),
        description: "認証コードを再送信しました。",
        icon: <SendCompleteIcon />,
        placement: "bottomRight",
      });
      dispatch(VerifyPhoneNumberActionCreators.handleResetAction());
    }
  }, [verifyPhoneNumberData]);

  useEffect(() => {
    if (voiceCallData) {
      if (voiceCallData.status === httpStatus.StatusOK) {
        notification.open({
          message: moment(new Date()).format("YYYY/MM/DD HH:mm"),
          description: "ご登録した電話番号に発信しました。",
          icon: <SendCompleteIcon />,
          placement: "bottomRight",
        });
      } else {
        setError("OTPを送信できません。もしくは電話番号が間違っています。");
      }

      dispatch(VoiceCallActionCreators.handleResetAction());
    }
  }, [voiceCallData]);

  return (
    <Wrapper>
      <Title>{superCityName}登録</Title>
      <Text>認証コードを入力</Text>
      <SecondText>
        <span>{phone}</span>{" "}
        に認証コードを送りました。コードを入力して登録を行ってください。
      </SecondText>
      <div
        style={{ display: "flex", justifyContent: "center", marginBottom: 24 }}
      >
        <OTPInput length={4} onComplete={handleOTPComplete} />
      </div>

      {error && <WrapperError>{error}</WrapperError>}
      <ThirdText>※SMS認証コードが届かない場合の方へ</ThirdText>
      <FourText
        onClick={() => {
          dispatch(
            VerifyPhoneNumberActionCreators.verifyPhoneNumberAction({
              mobile_number: phone,
              super_city_code: superCityCode,
            })
          );
        }}
      >
        認証コードを再送信する
      </FourText>
      <FiveText
        onClick={() => {
          dispatch(
            VoiceCallActionCreators.voiceCallAction({
              mobile_number: phone,
            })
          );
        }}
      >
        電話をかけて認証する（非通知で電話がきます）
      </FiveText>

      <Button
        name="次　へ"
        background="#2F8CAE"
        color="#FFFFFF"
        border="none"
        fontSize={16}
        fontWeight={700}
        padding="7.5px 16px"
        width="100%"
        onClick={handleVerify}
        disabled={isLoading}
      />
    </Wrapper>
  );
};

export default VerifyOTP;
